import React from 'react';

export const AboutPage: React.FC = () => {
  return (
    <div className="page-container">
      <h1>Welcome to AiGrids</h1>
      
      <section className="about-section">
        <h2>Reimagining Spatial Data</h2>
        <p>
          AiGrids is in development. This is version 0.8 
        </p>
	<p>  
          AiGrids represents a breakthrough in spatial interpolation, harnessing 
          the power of machine learning to transform how we predict between
          sparse spatial data. Traditional statistical methods don't capture 
          the complexity of real-world surfaces, AiGrids introduces 
          neural networks trained on Earth's actual topography.
        </p>
      </section>
      
      <section className="about-section">
        <h2>The AI Advantage</h2>
        <p>
          Unlike conventional interpolation methods that rely on mathematical 
          approximations, our AI models train on real-world terrain.
          This means they predict surfaces that incorporate natural 
          features and relationships that statistical methods, leveraging
          only your sparse data, will miss.
        </p>
      </section>
      
      <section className="about-section">
        <h2>Seamless Experience</h2>
        <ul className="feature-list">
          <li>
            <strong>Intuitive Workflow</strong>
            <p>Upload data, preview results, and generate professional visualizations in minutes</p>
          </li>
          <li>
            <strong>Smart Processing</strong>
            <p>Automatic coordinate system detection and optimization</p>
          </li>
          <li>
            <strong>Real-time Customization</strong>
            <p>Interactive contour and visualization controls</p>
          </li>
          <li>
            <strong>Universal Compatibility</strong>
            <p>Export to industry-standard formats</p>
          </li>
        </ul>
      </section>
      
      <section className="about-section">
        <h2>Looking Forward</h2>
        <p>
          AiGrids represents the first step in a larger vision where AI transforms 
          spatial data analysis. Today we're focusing on surface interpolation, but 
          this is just the beginning. We're committed to expanding our AI capabilities 
          and bringing cutting-edge spatial analysis tools to everyone who works with 
          geographic data.
        </p>
      </section>

      <section className="about-section">
        <h2>Get Started</h2>
        <p>
          Try our demo datasets to experience the AI difference, then seamlessly 
          transition to your own data. Pay only for the interpolations you use.
        </p>
        <p>
          Questions? Chill out this is in development.
        </p>
      </section>
    </div>
  );
};
